import z from "zod";

export const usernameSchema = z
  .string()
  .min(5, "username_too_less")
  .max(30, "username_too_long")
  .regex(/^[a-zA-Z][a-zA-Z0-9_]*$/, "username_validation_error")
  .transform((val) => val.toLowerCase());
